import React from "react";

export default function Blog() {
  return (
    <div className="">
      <div className="flex flex-col text-center justify-center align-middle p-16">
        <h1 className="text-6xl border--2 border-ambhosOrange font-bold mb-3 pb-2">
          Blog
        </h1>
        <hr />
      </div>

      <div className="h-96 flex justify-center items-center text-7xl font-extrabold text-gray-300">
        <h3>Coming Soon...</h3>
      </div>

      {/* Blog List
      <div className="p-5 mt-5 rounded-xl bg-ambhosLiteOrange">
        <h2 className="text-2xl text-ambhosOrange font-semibold">
          This is the Blog Title
        </h2>
        <h3 className="text-md">Author Name</h3>
        <h4 className="text-sm">Category | 20th Apr,23</h4>
        <p className="text-md mt-3">
          Description - Lorem ipsum, dolor sit amet consectetur adipisicing
          elit. Consequatur, deserunt! Lorem ipsum, dolor sit amet consectetur
          adipisicing elit. Doloribus, corporis. Lorem ipsum dolor sit amet
          consectetur adipisicing elit. Debitis voluptate impedit optio, soluta
          ea consequuntur eos quo repudiandae eius libero?
        </p>
        <button className="border-2 border-ambhosOrange rounded-md px-2 py-1 mt-3 text-ambhosOrange">
          Read More
        </button>
      </div>
      <div className="border-2 p-5 mt-5 rounded-xl border-ambhosLiteOrange">
        <h2 className="text-2xl text-ambhosOrange font-semibold">
          This is the Blog Title
        </h2>
        <h3 className="text-md">Author Name</h3>
        <h4 className="text-sm">Category | 20th Apr,23</h4>
        <p className="text-md mt-3">
          Description - Lorem ipsum, dolor sit amet consectetur adipisicing
          elit. Consequatur, deserunt! Lorem ipsum, dolor sit amet consectetur
          adipisicing elit. Doloribus, corporis. Lorem ipsum dolor sit amet
          consectetur adipisicing elit. Debitis voluptate impedit optio, soluta
          ea consequuntur eos quo repudiandae eius libero?
        </p>
        <button className="border-2 border-ambhosOrange rounded-md px-2 py-1 mt-3 text-ambhosOrange">
          Read More
        </button>
      </div>
      <div className="border-2 border-ambhosOrange p-5 mt-5 rounded-xl ">
        <h2 className="text-2xl text-ambhosOrange font-semibold">
          This is the Blog Title
        </h2>
        <h3 className="text-md">Author Name</h3>
        <h4 className="text-sm">Category | 20th Apr,23</h4>
        <p className="text-md mt-3">
          Description - Lorem ipsum, dolor sit amet consectetur adipisicing
          elit. Consequatur, deserunt! Lorem ipsum, dolor sit amet consectetur
          adipisicing elit. Doloribus, corporis. Lorem ipsum dolor sit amet
          consectetur adipisicing elit. Debitis voluptate impedit optio, soluta
          ea consequuntur eos quo repudiandae eius libero?
        </p>
        <button className="border-2 border-ambhosOrange bg-ambhosOrange rounded-md px-2 py-1 mt-3 text-white">
          Read More
        </button>
      </div>
      <div className="border-2 p-5 mt-5 rounded-xl ">
        <h2 className="text-2xl text-ambhosOrange font-semibold">
          This is the Blog Title
        </h2>
        <h3 className="text-md">Author Name</h3>
        <h4 className="text-sm">Category | 20th Apr,23</h4>
        <p className="text-md mt-3">
          Description - Lorem ipsum, dolor sit amet consectetur adipisicing
          elit. Consequatur, deserunt! Lorem ipsum, dolor sit amet consectetur
          adipisicing elit. Doloribus, corporis. Lorem ipsum dolor sit amet
          consectetur adipisicing elit. Debitis voluptate impedit optio, soluta
          ea consequuntur eos quo repudiandae eius libero?
        </p>
      </div>
      <div className="border-2 p-5 mt-5 rounded-xl ">
        <h2 className="text-2xl text-ambhosOrange font-semibold">
          This is the Blog Title
        </h2>
        <h3 className="text-md">Author Name</h3>
        <h4 className="text-sm">Category | 20th Apr,23</h4>
        <p className="text-md mt-3">
          Description - Lorem ipsum, dolor sit amet consectetur adipisicing
          elit. Consequatur, deserunt! Lorem ipsum, dolor sit amet consectetur
          adipisicing elit. Doloribus, corporis. Lorem ipsum dolor sit amet
          consectetur adipisicing elit. Debitis voluptate impedit optio, soluta
          ea consequuntur eos quo repudiandae eius libero?
        </p>
      </div> */}
    </div>
  );
}
